import LearningMaterials from "@components/LearningMaterials";
import styles from "./styles.module.scss";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { steps } from "./utils";
import FlagBannerFold from "../../assets/icons/FlagBannerFold.svg";
import classNames from "classnames";

const FlowProgressLineSecond = ({ activeStep }: { activeStep: number }) => {
  const [modal, setModal] = useState(false);

  const shouldShowLearning = [1, 2, 3, 4].includes(activeStep);

  return (
    <div className={styles.container}>
      <div className={styles.timeline}>
        {steps.map((step, index) => {
          const isActive = index === activeStep - 3;
          const isCompleted =
            index < 2 || (index >= 2 && index < activeStep - 3);
          const isLastStep = index === steps.length - 1;

          return (
            <div key={index} className={styles.step}>
              <div
                className={classNames(styles.circle, {
                  [styles.active]: isActive && !isLastStep,
                  [styles.completed]: isCompleted && !isLastStep,
                  [styles.circleLast]: isLastStep,
                })}
              >
                {typeof step.id === "number" ? (
                  (() => {
                    const displayId = step.id >= 5 ? step.id - 4 : step.id;
                    return displayId;
                  })()
                ) : (
                  <img
                    src={FlagBannerFold}
                    alt="Completion Flag"
                    width={15}
                    height={15}
                  />
                )}
              </div>
              <div className={styles.label}>
                <span
                  className={classNames({
                    [styles.textActive]: isActive && !isLastStep,
                    [styles.textCompleted]: isCompleted && !isLastStep,
                    [styles.labelLast]: isLastStep,
                  })}
                >
                  {step.title}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {shouldShowLearning && (
        <LearningMaterials setModal={setModal} activeStep={activeStep} />
      )}
    </div>
  );
};

export default FlowProgressLineSecond;
